import { format, isValid, parse, parseISO } from 'date-fns';

import { DATE_FORMATS } from '@/utils/date-formats';

/** Parse a note date that may be ISO or the legacy "EEEE, MMMM d, yyyy" display format. */
export function parseNoteDate(raw: string): Date {
  const trimmed = raw.trim();
  if (!trimmed) return new Date(0);

  const iso = parseISO(trimmed);
  if (isValid(iso)) return iso;

  const normalized = trimmed.replace(/,(\d{4})$/, ', $1');
  const parsed = parse(normalized, 'EEEE, MMMM d, yyyy', new Date());
  return isValid(parsed) ? parsed : new Date(0);
}

/** Display format for a note's created date; falls back to the raw value when unparseable. */
export function formatNoteDate(raw: string): string {
  const date = parseNoteDate(raw);
  if (date.getTime() <= 0) return raw.trim().replace(/,(\d{4})$/, ', $1');
  return format(date, DATE_FORMATS.TEXT_WEEKDAY);
}
